import { useTranslation } from 'react-i18next';
import { type ActionMethods, type PageTypes, type UserSelfPageData } from '..';
import EditIcon from '../../../../assets/ci/profile/edit.svg';
import PageTitle from '../PageTitle';
import { ActionButton } from '../styled';
import ViewProfileContent from './ViewProfileContent';

type useViewProfilePageDataProps = {
    actions: ActionMethods;
    onMenuItemClicked: (pageType: PageTypes) => void;
};

const useViewProfilePageData = ({ actions, onMenuItemClicked }: useViewProfilePageDataProps) => {
    const { t } = useTranslation('userSelf');
    const page: UserSelfPageData = {
        type: 'viewProfile',
        title: (
            <PageTitle
                extra={<ActionButton icon={<EditIcon />} onClick={actions.goToEditProfile} type="link" />}
                title={t('userSelf:myProfile.title')}
            />
        ),
        body: <ViewProfileContent onMenuItemClicked={onMenuItemClicked} />,
        onMenuItemClicked: actions.goBackToViewProfile,
        onCloseOrBackClicked: actions.closeDrawer,
    };

    return page;
};

export default useViewProfilePageData;
